import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { appRouteChildGuard, appRouteMatchGuard } from '../guards/app-route.guard';
import { ViewportService } from '../services/viewport.service';

export function withAppGuard(routes: Routes): Routes {
  return routes.map((route) => {
    if (route.redirectTo !== undefined) {
      return route;
    }

    return {
      ...route,
      canMatch: [appRouteMatchGuard, ...(route.canMatch ?? [])],
      canActivateChild: [appRouteChildGuard, ...(route.canActivateChild ?? [])],
    };
  });
}

export function initialRedirect(appPath: string, webPath: string): () => string {
  return () => (inject(ViewportService).isApp() ? appPath : webPath);
}
